import { render } from "./report-list.vue?vue&type=template&id=610280eb"
import script from "./report-list.vue?vue&type=script&lang=js"
export * from "./report-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__